import React from "react";
import { Colors } from "../../utils/colors";
import tick from "../../assets/tick.png";
import { TCText } from "../TCText/TCText";
import { BorderButton } from "../borderButton/BorderButton";
import { useSectionStore } from "../../stores/StoreContext";

type props = {};

export const SelectDateTimeHeader: React.FC<props> = () => {
  const sectionStore = useSectionStore();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
      }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: 10,
        }}>
        <div
          style={{
            width: 24,
            height: 24,
            borderRadius: 12,
            backgroundColor: Colors.green,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
          <img src={tick} alt="tick" width={12} height={8} />
        </div>
        <TCText
          style={{ fontWeight: 600, fontSize: 14 }}
          value="Selected day and time"
        />
      </div>
      <BorderButton
        onPress={() => {
          sectionStore.onDateTimeEdit();
        }}
      />
    </div>
  );
};
